import styled from '@emotion/styled';
import { SvgIcon, SvgNames, tokens } from '@sunrun/experience-ui-components';
import { ListViewCellText } from 'components/atoms/ListViewCellText';

const ListViewReferredByCell = ({ referredBy }: { referredBy?: string }) => {
  if (referredBy) {
    return <ListViewCellText>{referredBy}</ListViewCellText>;
  }

  return (
    <NotEntered>
      <ListViewCellText $warning>Not entered</ListViewCellText>
      <ReferredByWarningIcon
        name={SvgNames.ErrorOutline}
        width={16}
        height={16}
        color={tokens.ERROR_50}
      />
    </NotEntered>
  );
};

const NotEntered = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
`;

const ReferredByWarningIcon = styled(SvgIcon)`
  margin: auto 0;
`;

export { ListViewReferredByCell };
